var map = {
	"./game-1.png": 138,
	"./game-10.png": 384,
	"./game-11.png": 0,
	"./game-2.png": 73,
	"./game-3.png": 980,
	"./game-4.png": 44,
	"./game-5.png": 19,
	"./game-6.png": 564,
	"./game-7.png": 540,
	"./game-8.png": 714,
	"./game-9.png": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485;